// extracted by mini-css-extract-plugin
module.exports = {"cooperation":"PcCooperation_cooperation_2WIas","cooperationList":"PcCooperation_cooperationList_Y65dW","cooperationItem":"PcCooperation_cooperationItem_2Iz5V"};